// Belgian postcodes mapping - city name (lowercase) -> postal code
// Complete list of 596 Belgian municipalities - synced with backend
// Source: /app/backend/belgian_postcodes.py

const BELGIAN_POSTCODES = {
  "'s-gravenbrakel": "7090",
  "aalst": "9300",
  "aalter": "9880",
  "aarlen": "6700",
  "aarschot": "3200",
  "aartselaar": "2630",
  "aat": "7800",
  "affligem": "1790",
  "afsnee": "9051",
  "aiseau-presles": "6250",
  "alken": "3570",
  "alost": "9300",
  "alsemberg": "1652",
  "amay": "4540",
  "andenne": "5300",
  "anderlecht": "1070",
  "anhée": "5537",
  "ans": "4430",
  "anthisnes": "4160",
  "antwerp": "2000",
  "antwerpen": "2000",
  "anvers": "2000",
  "anzegem": "8570",
  "ardooie": "8850",
  "arendonk": "2370",
  "arlon": "6700",
  "as": "3665",
  "asse": "1730",
  "assebroek": "8310",
  "assenede": "9960",
  "assesse": "5330",
  "ath": "7800",
  "attert": "6717",
  "aubange": "6790",
  "aubel": "4880",
  "audenarde": "9700",
  "auderghem": "1160",
  "avelgem": "8580",
  "awans": "4340",
  "aywaille": "4920",
  "baelen": "4837",
  "balen": "2490",
  "bassenge": "4690",
  "bastenaken": "6600",
  "bastogne": "6600",
  "beaumont": "6500",
  "beauraing": "5570",
  "beernem": "8730",
  "beerse": "2340",
  "beersel": "1650",
  "beloeil": "7970",
  "berchem": "2600",
  "berchem-sainte-agathe": "1082",
  "bergen": "7000",
  "beringen": "3580",
  "berlaar": "2590",
  "berlare": "9290",
  "bernissart": "7320",
  "bertogne": "6687",
  "bertrix": "6880",
  "bever": "1547",
  "beveren": "9120",
  "beyne-heusay": "4610",
  "bilzen": "3740",
  "binche": "7130",
  "bièvre": "5555",
  "blankenberge": "8370",
  "blegny": "4670",
  "boechout": "2530",
  "bonheiden": "2820",
  "boom": "2850",
  "borchtlombeek": "1761",
  "borgerhout": "2140",
  "borgloon": "3840",
  "borgworm": "4300",
  "bouillon": "6830",
  "boussu": "7300",
  "braine-l'alleud": "1420",
  "braine-le-comte": "7090",
  "braives": "4260",
  "brakel": "9660",
  "brasschaat": "2930",
  "bredene": "8450",
  "bree": "3960",
  "bruges": "8000",
  "brugge": "8000",
  "brussel": "1000",
  "brussels": "1000",
  "bruxelles": "1000",
  "buggenhout": "9255",
  "burdinne": "4210",
  "bütgenbach": "4750",
  "cerfontaine": "5630",
  "chapelle-lez-herlaimont": "7160",
  "charleroi": "6000",
  "chaudfontaine": "4050",
  "chimay": "6460",
  "chiny": "6810",
  "châtelet": "6200",
  "ciney": "5590",
  "clavier": "4560",
  "colfontaine": "7340",
  "comblain-au-pont": "4170",
  "comines-warneton": "7780",
  "courcelles": "6180",
  "courtrai": "8500",
  "couvin": "5660",
  "crisnée": "4367",
  "dalhem": "4607",
  "damme": "8340",
  "daverdisse": "6929",
  "de haan": "8420",
  "de panne": "8660",
  "de pinte": "9840",
  "deerlijk": "8540",
  "deinze": "9800",
  "denderleeuw": "9470",
  "dendermonde": "9200",
  "dentergem": "8720",
  "dessel": "2480",
  "destelbergen": "9070",
  "desteldonk": "9042",
  "deurne": "2100",
  "diegem": "1831",
  "diepenbeek": "3590",
  "diest": "3290",
  "diksmuide": "8600",
  "dilbeek": "1700",
  "dilsen-stokkem": "3650",
  "dinant": "5500",
  "dison": "4820",
  "dixmude": "8600",
  "doornik": "7500",
  "dour": "7370",
  "drongen": "9031",
  "dudzele": "8380",
  "duffel": "2570",
  "durbuy": "6940",
  "ecaussinnes": "7190",
  "edegem": "2650",
  "edingen": "7850",
  "eeklo": "9900",
  "eghezée": "5310",
  "eigenbrakel": "1420",
  "ekeren": "2180",
  "elsene": "1050",
  "emblem": "2520",
  "enghien": "7850",
  "engis": "4480",
  "erezée": "6997",
  "erpe-mere": "9420",
  "erpent": "5101",
  "erquelinnes": "6560",
  "esneux": "4130",
  "essen": "2910",
  "etterbeek": "1040",
  "eupen": "4700",
  "evere": "1140",
  "evergem": "9940",
  "farciennes": "6240",
  "fauvillers": "6637",
  "fernelmont": "5380",
  "ferrières": "4190",
  "fexhe-le-haut-clocher": "4347",
  "fleurus": "6220",
  "floreffe": "5150",
  "florennes": "5620",
  "florenville": "6820",
  "flémalle": "4400",
  "fléron": "4620",
  "fontaine-l'évêque": "6140",
  "forest": "1190",
  "fosses-la-ville": "5070",
  "frameries": "7080",
  "froidchapelle": "6440",
  "furnes": "8630",
  "galmaarden": "1570",
  "gand": "9000",
  "ganshoren": "1083",
  "gavere": "9890",
  "gedinne": "5575",
  "geel": "2440",
  "geldenaken": "1370",
  "gembloux": "5030",
  "genk": "3600",
  "gent": "9000",
  "gentbrugge": "9050",
  "genval": "1332",
  "geraardsbergen": "9500",
  "gerpinnes": "6280",
  "gesves": "5340",
  "ghent": "9000",
  "gingelom": "3890",
  "gistel": "8470",
  "gooik": "1755",
  "gouvy": "6670",
  "grammont": "9500",
  "grez-doiceau": "1390",
  "grimbergen": "1850",
  "grobbendonk": "2280",
  "groot-bijgaarden": "1702",
  "grâce-hollogne": "4460",
  "haacht": "3150",
  "haaltert": "9450",
  "habay": "6720",
  "hal": "1500",
  "halle": "1500",
  "ham": "3945",
  "ham-sur-heure-nalinnes": "6120",
  "hamme": "9220",
  "hamoir": "4180",
  "hamois": "5360",
  "hamont-achel": "3930",
  "hannuit": "4280",
  "hannut": "4280",
  "harelbeke": "8530",
  "haren": "1130",
  "hasselt": "3500",
  "hastière": "5540",
  "havelange": "5370",
  "hechtel-eksel": "3940",
  "heers": "3870",
  "heist": "8301",
  "heist-op-den-berg": "2220",
  "hemiksem": "2620",
  "hensies": "7350",
  "herbeumont": "6887",
  "herentals": "2200",
  "herne": "1541",
  "herstal": "4040",
  "herve": "4650",
  "herzele": "9550",
  "heusden-zolder": "3550",
  "heuvelland": "8950",
  "heverlee": "3001",
  "hoboken": "2660",
  "hoei": "4500",
  "hoeilaart": "1560",
  "hoeselt": "3730",
  "hooglede": "8830",
  "hoogstraten": "2320",
  "hotton": "6990",
  "houffalize": "6660",
  "houthalen-helchteren": "3530",
  "houthulst": "8650",
  "houyet": "5560",
  "hove": "2540",
  "huizingen": "1654",
  "hulshout": "2235",
  "huy": "4500",
  "héron": "4217",
  "ichtegem": "8480",
  "ieper": "8900",
  "ingelmunster": "8770",
  "ixelles": "1050",
  "izegem": "8870",
  "jabbeke": "8490",
  "jalhay": "4845",
  "jambes": "5100",
  "jemappes": "7012",
  "jemeppe-sur-sambre": "5190",
  "jette": "1090",
  "jodoigne": "1370",
  "juprelle": "4450",
  "kalmthout": "2920",
  "kapelle-op-den-bos": "1880",
  "kapellen": "2950",
  "kaprijke": "9970",
  "kelmis": "4720",
  "kessel-lo": "3010",
  "kinrooi": "3640",
  "kluisbergen": "9690",
  "knesselare": "9910",
  "knokke": "8300",
  "knokke-heist": "8300",
  "koekelare": "8680",
  "koekelberg": "1081",
  "koksijde": "8670",
  "komen-waasten": "7780",
  "kontich": "2550",
  "kortemark": "8610",
  "kortessem": "3720",
  "kortrijk": "8500",
  "kraainem": "1950",
  "kruibeke": "9150",
  "kruishoutem": "9770",
  "kuurne": "8520",
  "la bruyère": "5080",
  "la calamine": "4720",
  "la hulpe": "1310",
  "la louvière": "7100",
  "la roche-en-ardenne": "6980",
  "laakdal": "2430",
  "laarne": "9270",
  "laeken": "1020",
  "laken": "1020",
  "lanaken": "3620",
  "langemark-poelkapelle": "8920",
  "lasne": "1380",
  "lebbeke": "9280",
  "lede": "9340",
  "ledeberg": "9050",
  "ledegem": "8880",
  "lennik": "1750",
  "leopoldsburg": "3970",
  "les bons villers": "6210",
  "lessen": "7860",
  "lessines": "7860",
  "leuven": "3000",
  "leuze-en-hainaut": "7900",
  "libin": "6890",
  "libramont-chevigny": "6800",
  "lichtervelde": "8810",
  "liedekerke": "1770",
  "liege": "4000",
  "lier": "2500",
  "lierde": "9570",
  "lierre": "2500",
  "lille": "2275",
  "limbourg": "4830",
  "lint": "2547",
  "lissewege": "8380",
  "liège": "4000",
  "lo-reninge": "8647",
  "lobbes": "6540",
  "lochristi": "9080",
  "lokeren": "9160",
  "lommel": "3920",
  "londerzeel": "1840",
  "lontzen": "4710",
  "lot": "1651",
  "louvain": "3000",
  "louvain-la-neuve": "1348",
  "lovendegem": "9920",
  "luik": "4000",
  "léglise": "6860",
  "maaseik": "3680",
  "maasmechelen": "3630",
  "machelen": "1830",
  "maldegem": "9990",
  "malines": "2800",
  "malle": "2390",
  "malmedy": "4960",
  "manage": "7170",
  "manhay": "6960",
  "marche-en-famenne": "6900",
  "marchienne-au-pont": "6030",
  "marchin": "4570",
  "marcinelle": "6001",
  "mariakerke": "9030",
  "martelange": "6630",
  "mechelen": "2800",
  "meerhout": "2450",
  "meise": "1860",
  "melle": "9090",
  "melsbroek": "1820",
  "menen": "8930",
  "menin": "8930",
  "merbes-le-château": "6567",
  "merchtem": "1785",
  "merelbeke": "9820",
  "merksem": "2170",
  "merksplas": "2330",
  "messancy": "6780",
  "mettet": "5640",
  "middelkerke": "8430",
  "modave": "4577",
  "moerbeke": "9180",
  "moeskroen": "7700",
  "mol": "2400",
  "molenbeek": "1080",
  "molenbeek-saint-jean": "1080",
  "mons": "7000",
  "montigny-le-tilleul": "6110",
  "moorslede": "8890",
  "morlanwelz": "7140",
  "mortsel": "2640",
  "mouscron": "7700",
  "namen": "5000",
  "namur": "5000",
  "nandrin": "4550",
  "nassogne": "6950",
  "nazareth": "9810",
  "neder-over-heembeek": "1120",
  "neerpelt": "3910",
  "neufchâteau": "6840",
  "neupré": "4121",
  "nevele": "9850",
  "niel": "2845",
  "nieuwerkerken": "3850",
  "nieuwpoort": "8620",
  "nijlen": "2560",
  "nijvel": "1400",
  "ninove": "9400",
  "nivelles": "1400",
  "nossegem": "1930",
  "ohey": "5350",
  "olen": "2250",
  "olne": "4877",
  "onhaye": "5520",
  "oostakker": "9041",
  "oostduinkerke": "8670",
  "oostende": "8400",
  "oosterzele": "9860",
  "oostkamp": "8020",
  "oostrozebeke": "8780",
  "opglabbeek": "3660",
  "opwijk": "1745",
  "oreye": "4360",
  "ostende": "8400",
  "ottignies": "1340",
  "oud-turnhout": "2360",
  "oudenaarde": "9700",
  "oudenburg": "8460",
  "oudergem": "1160",
  "ouffet": "4590",
  "oupeye": "4680",
  "overijse": "3090",
  "overpelt": "3900",
  "paliseul": "6850",
  "peer": "3990",
  "pepingen": "1670",
  "pepinster": "4860",
  "peutie": "1830",
  "philippeville": "5600",
  "pittem": "8740",
  "plombières": "4850",
  "pont-à-celles": "6230",
  "poperinge": "8970",
  "profondeville": "5170",
  "putte": "2580",
  "péruwelz": "7600",
  "quaregnon": "7390",
  "quiévrain": "7380",
  "raeren": "4730",
  "ranst": "2520",
  "ravels": "2380",
  "rebecq": "1430",
  "remicourt": "4350",
  "renaix": "9600",
  "rendeux": "6987",
  "retie": "2470",
  "riemst": "3770",
  "rixensart": "1330",
  "rochefort": "5580",
  "roeselare": "8800",
  "ronse": "9600",
  "roosdaal": "1760",
  "roulers": "8800",
  "rumst": "2840",
  "saint-ghislain": "7330",
  "saint-gilles": "1060",
  "saint-hubert": "6870",
  "saint-nicolas": "4420",
  "saint-servais": "5002",
  "saint-trond": "3800",
  "saint-vith": "4780",
  "sainte-ode": "6680",
  "salzinnes": "5000",
  "sambreville": "5060",
  "sankt vith": "4780",
  "schaarbeek": "1030",
  "schaerbeek": "1030",
  "schelle": "2627",
  "schilde": "2970",
  "schoten": "2900",
  "seneffe": "7180",
  "seraing": "4100",
  "silly": "7830",
  "sint-agatha-berchem": "1082",
  "sint-amandsberg": "9040",
  "sint-andries": "8200",
  "sint-denijs-westrem": "9051",
  "sint-gillis": "1060",
  "sint-jans-molenbeek": "1080",
  "sint-katelijne-waver": "2860",
  "sint-katherina-lombeek": "1742",
  "sint-kruis": "8310",
  "sint-kwintens-lennik": "1750",
  "sint-lambrechts-woluwe": "1200",
  "sint-lievens-houtem": "9520",
  "sint-martens-latem": "9830",
  "sint-michiels": "8200",
  "sint-niklaas": "9100",
  "sint-pieters-leeuw": "1600",
  "sint-pieters-woluwe": "1150",
  "sint-truiden": "3800",
  "sivry-rance": "6470",
  "soignies": "7060",
  "sombreffe": "5140",
  "somme-leuze": "5377",
  "soumagne": "4630",
  "spa": "4900",
  "spiere-helkijn": "8587",
  "sprimont": "4140",
  "stabroek": "2940",
  "staden": "8840",
  "stavelot": "4970",
  "steenokkerzeel": "1820",
  "stekene": "9190",
  "sterrebeek": "1933",
  "strombeek-bever": "1853",
  "tellin": "6927",
  "temse": "9140",
  "tenneville": "6970",
  "terhulpen": "1310",
  "termonde": "9200",
  "ternat": "1740",
  "tervuren": "3080",
  "tessenderlo": "3980",
  "theux": "4910",
  "thuin": "6530",
  "tielt": "8700",
  "tienen": "3300",
  "tinlot": "4557",
  "tintigny": "6730",
  "tirlemont": "3300",
  "tongeren": "3700",
  "tongres": "3700",
  "torhout": "8820",
  "tournai": "7500",
  "trooz": "4870",
  "tubeke": "1480",
  "tubize": "1480",
  "turnhout": "2300",
  "uccle": "1180",
  "ukkel": "1180",
  "vaux-sur-sûre": "6640",
  "verviers": "4800",
  "veurne": "8630",
  "vielsalm": "6690",
  "vilvoorde": "1800",
  "viroinval": "5670",
  "visé": "4600",
  "vorselaar": "2290",
  "vorst": "1190",
  "vosselaar": "2350",
  "vremde": "2531",
  "vresse-sur-semois": "5550",
  "waarschoot": "9950",
  "wachtebeke": "9185",
  "waimes": "4950",
  "walcourt": "5650",
  "wanze": "4520",
  "waregem": "8790",
  "waremme": "4300",
  "waterloo": "1410",
  "watermaal-bosvoorde": "1170",
  "watermael-boitsfort": "1170",
  "waver": "1300",
  "wavre": "1300",
  "welkenraedt": "4840",
  "wellen": "3830",
  "wellin": "6920",
  "wenduine": "8420",
  "wervik": "8940",
  "westerlo": "2260",
  "wetteren": "9230",
  "wevelgem": "8560",
  "weverstraat": "1761",
  "wezembeek-oppem": "1970",
  "wezet": "4600",
  "wichelen": "9260",
  "wielsbeke": "8710",
  "wijnegem": "2110",
  "wilrijk": "2610",
  "wilsele": "3012",
  "woluwe-saint-lambert": "1200",
  "woluwe-saint-pierre": "1150",
  "wolvertem": "1861",
  "wommelgem": "2160",
  "wondelgem": "9032",
  "wortegem-petegem": "9790",
  "wuustwezel": "2990",
  "wépion": "5100",
  "ypres": "8900",
  "yvoir": "5530",
  "zandhoven": "2240",
  "zaventem": "1930",
  "zedelgem": "8210",
  "zeebrugge": "8380",
  "zele": "9240",
  "zellik": "1731",
  "zelzate": "9060",
  "zinnik": "7060",
  "zoersel": "2980",
  "zomergem": "9930",
  "zonhoven": "3520",
  "zonnebeke": "8980",
  "zottegem": "9620",
  "zoutleeuw": "3440",
  "zuienkerke": "8377",
  "zutendaal": "3690",
  "zwevegem": "8550",
  "zwijnaarde": "9052",
  "zwijndrecht": "2070",
  "étalle": "6740",
};

// Total: 596 Belgian municipalities

export function findPostcodeByCity(city, requireExactMatch = false) {
  if (!city || city.length < 2) return null;
  
  const normalizedCity = city.toLowerCase().trim()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Remove accents
  
  // Direct/exact match first - always check this
  if (BELGIAN_POSTCODES[normalizedCity]) {
    return BELGIAN_POSTCODES[normalizedCity];
  }
  
  // Also try the original (with potential accents)
  const cityLower = city.toLowerCase().trim();
  if (BELGIAN_POSTCODES[cityLower]) {
    return BELGIAN_POSTCODES[cityLower];
  }
  
  // If exact match required or input too short, don't do partial matching
  if (requireExactMatch || normalizedCity.length < 4) {
    return null;
  }
  
  // Try partial match only for longer inputs (4+ chars)
  for (const [cityName, postcode] of Object.entries(BELGIAN_POSTCODES)) {
    const normalizedCityName = cityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    if (normalizedCityName.includes(normalizedCity) || normalizedCity.includes(normalizedCityName)) {
      return postcode;
    }
  }
  
  return null;
}

// Helper function to properly capitalize city names (e.g., Sint-Katelijne-Waver)
function titleCase(str) {
  return str.split(/(-|\s)/).map(part => {
    if (part === '-' || part === ' ') return part;
    return part.charAt(0).toUpperCase() + part.slice(1);
  }).join('');
}

export function getSuggestions(input) {
  if (!input || input.length < 2) return [];
  
  const normalizedInput = input.toLowerCase().trim()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  
  const matches = [];
  const seen = new Set();
  
  for (const [cityName, postcode] of Object.entries(BELGIAN_POSTCODES)) {
    const normalizedCityName = cityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    if (normalizedCityName.includes(normalizedInput) || normalizedInput.includes(normalizedCityName)) {
      const key = `${postcode}-${cityName}`;
      if (!seen.has(key)) {
        seen.add(key);
        matches.push({ city: titleCase(cityName), postcode });
      }
    }
  }
  
  // Sort: exact starts first, then alphabetically
  matches.sort((a, b) => {
    const aStarts = a.city.toLowerCase().startsWith(normalizedInput);
    const bStarts = b.city.toLowerCase().startsWith(normalizedInput);
    if (aStarts && !bStarts) return -1;
    if (!aStarts && bStarts) return 1;
    return a.city.localeCompare(b.city);
  });
  
  return matches.slice(0, 10);
}

export default BELGIAN_POSTCODES;
